// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `footer {
    position: fixed;
    bottom: 0;
    text-align: center;
    width: 460px;
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-bottom: 1rem;
 }
 .footer p {
    color: var(--Text-Color-Default, #333);
    font-family: "McKinseySans-Light", sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 16px;
 }
 .footer a {
    color: var(--Text-InverseInteraction, #34B4F4);
    font-family: "McKinseySans-Light", sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: 16px;
    text-decoration-line: none;
 }`, "",{"version":3,"sources":["webpack://./src/components/footer/styles.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;CACtB;CACA;IACG,sCAAsC;IACtC,6CAA6C;IAC7C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;CACpB;CACA;IACG,8CAA8C;IAC9C,6CAA6C;IAC7C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;CAC7B","sourcesContent":["footer {\n    position: fixed;\n    bottom: 0;\n    text-align: center;\n    width: 460px;\n    display: flex;\n    justify-content: center;\n    gap: 8px;\n    margin-bottom: 1rem;\n }\n .footer p {\n    color: var(--Text-Color-Default, #333);\n    font-family: \"McKinseySans-Light\", sans-serif;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 300;\n    line-height: 16px;\n }\n .footer a {\n    color: var(--Text-InverseInteraction, #34B4F4);\n    font-family: \"McKinseySans-Light\", sans-serif;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 300;\n    line-height: 16px;\n    text-decoration-line: none;\n }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
